import { SettingOutlined } from '@ant-design/icons';
import { Collapse, Flex, Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useVendorErrorCodeEnumOptions } from '~/app/components/errorManagement/ErrorManagementPage/hooks/useVendorErrorCodeEnumOptions';

export function VendorErrorCodeAdvancedFields() {
  const { t } = useTranslation('errorManagement');
  const {
    parameterOptions,
    stateOptions,
    impactedComponentOptions,
    categoryOptions,
    severityOptions,
  } = useVendorErrorCodeEnumOptions();

  return (
    <Collapse
      ghost
      styles={{
        header: {
          background:
            'color-mix(in srgb, var(--evimo-warning) 8%, transparent)',
          borderRadius: 10,
          paddingInline: 12,
        },
      }}
      items={[
        {
          key: 'advanced',
          label: (
            <Flex align="center" gap={8}>
              <SettingOutlined style={{ color: 'var(--evimo-warning)' }} />
              <span>{t('drawer.advancedFields')}</span>
            </Flex>
          ),
          children: (
            <>
              <Form.Item name="matchType" label={t('drawer.matchType')}>
                <Input />
              </Form.Item>
              <Form.Item name="matchKey" label={t('drawer.matchKey')}>
                <Input />
              </Form.Item>
              <Form.Item
                name="vendorErrorCode"
                label={t('drawer.vendorErrorCode')}
              >
                <Input />
              </Form.Item>
              <Form.Item name="info" label={t('drawer.info')}>
                <Input.TextArea rows={2} />
              </Form.Item>
              <Form.Item name="parameter" label={t('drawer.parameter')}>
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={parameterOptions}
                />
              </Form.Item>
              <Form.Item name="state" label={t('drawer.state')}>
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={stateOptions}
                />
              </Form.Item>
              <Form.Item
                name="impactedComponent"
                label={t('drawer.impactedComponent')}
              >
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={impactedComponentOptions}
                />
              </Form.Item>
              <Form.Item name="category" label={t('drawer.category')}>
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={categoryOptions}
                />
              </Form.Item>
              <Form.Item name="severity" label={t('drawer.severity')}>
                <Select
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  options={severityOptions}
                />
              </Form.Item>
              <Form.Item
                name="firmwareVersion"
                label={t('drawer.firmwareVersion')}
              >
                <Input />
              </Form.Item>
              <Form.Item name="description" label={t('drawer.description')}>
                <Input.TextArea rows={3} />
              </Form.Item>
            </>
          ),
        },
      ]}
    />
  );
}
